import { proxy, subscribe } from 'valtio';

import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';
import { diagram as diagramState } from '@diagram/state/diagram';

import { CurrentOSZones, CurrentOSZoneType, Zone } from 'models';

const zonesState = proxy<{
    zones: {
        control: Zone[];
        currentOS: CurrentOSZones;
        galvanic: Zone[];
        fault: Zone[];
        protection: Zone[];
    };
    highlight: Zone['id'] | null;
    temp: Zone | null;
    visibleCurrentOSZoneTypes: CurrentOSZoneType[];
    hoveredCurrentOSZoneType: CurrentOSZoneType | null;
}>({
    zones: {
        control: [],
        currentOS: {
            0: [],
            1: [],
            2.1: [],
            2.2: [],
            3: [],
            4: [],
        },
        galvanic: [],
        fault: [],
        protection: [],
    },
    highlight: null,
    temp: null,
    visibleCurrentOSZoneTypes: [],
    hoveredCurrentOSZoneType: null,
});

const recomputeZones = () => {
    const previousControlZones = zonesState.zones.control;
    const previousCurrentOSZones = zonesState.zones.currentOS;
    const previousGalvanicZones = zonesState.zones.galvanic;
    const previousFaultZones = zonesState.zones.fault;
    const previousProtectionZones = zonesState.zones.protection;

    zonesState.zones = {
        control: ZoneHelpers.generateControlZones(diagramState, previousControlZones),
        currentOS: ZoneHelpers.generateCurrentOSZones(diagramState, previousCurrentOSZones),
        galvanic: ZoneHelpers.generateGalvanicZones(diagramState, previousGalvanicZones),
        fault: ZoneHelpers.generateFaultZones(diagramState, previousFaultZones),
        protection: ZoneHelpers.generateProtectionZones(diagramState, previousProtectionZones),
    };
};

// `diagramState` and this module form a circular import (diagram → DiagramSyncService → … →
// ZoneService → zones). Registering the subscription synchronously would read `diagramState`
// while `diagram.ts` is still evaluating its imports, before `export const diagram` runs,
// throwing "Cannot access 'diagram' before initialization". Deferring to a microtask lets the
// whole module graph finish initializing first, regardless of chunk evaluation order.
if (typeof window !== 'undefined') {
    queueMicrotask(() => subscribe(diagramState, recomputeZones));
}

export { zonesState };
